<template>
  <v-overlay :opacity="0.99" :color="instance.theme.preload_background"  class="overlay-bck loaderSplash" >
    <div class="text-center">
      <img :src="instance.preload.logo" class="mx-auto" width="180"/>
      <h3 class="wrap-load"><b color="black">{{ $t('common.loading_label') }} </b> <span class="loader"></span></h3>
      <!-- <v-progress-circular indeterminate size="50" /> -->
      <div class="wrap-powered">
        <span>Powered by:</span>
        <svg width="240" height="86" viewBox="0 0 240 86" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_617_3" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="240" height="86">
        <path d="M239.077 0H0V85.135H239.077V0Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_617_3)">
        <path d="M76.7711 83.734H67.1711C66.7734 83.7341 66.3795 83.6559 66.012 83.5038C65.6445 83.3517 65.3106 83.1287 65.0293 82.8475C64.748 82.5663 64.5249 82.2324 64.3727 81.865C64.2204 81.4976 64.1421 81.1037 64.1421 80.706V3.029C64.142 2.63127 64.2202 2.23742 64.3723 1.86993C64.5244 1.50244 64.7474 1.16852 65.0286 0.887234C65.3098 0.605953 65.6437 0.382822 66.0111 0.230589C66.3785 0.0783548 66.7724 1.43506e-07 67.1701 1.65195e-07H76.7701C77.1679 -0.000131234 77.5618 0.0781265 77.9294 0.230301C78.2969 0.382476 78.6309 0.605586 78.9122 0.886881C79.1935 1.16818 79.4166 1.50214 79.5688 1.8697C79.721 2.23725 79.7992 2.63119 79.7991 3.029V80.706C79.7991 81.1037 79.7207 81.4976 79.5685 81.865C79.4163 82.2324 79.1931 82.5663 78.9119 82.8475C78.6306 83.1287 78.2967 83.3517 77.9292 83.5038C77.5617 83.6559 77.1688 83.7341 76.7711 83.734Z" fill="white"/>
        <path d="M120.004 85.122C136.955 85.122 150.698 74.564 150.698 53.522V26.522C150.698 26.1243 150.62 25.7304 150.468 25.3629C150.316 24.9954 150.093 24.6615 149.812 24.3802C149.53 24.0989 149.196 23.8758 148.829 23.7236C148.462 23.5713 148.068 23.493 147.67 23.493H138.07C137.672 23.493 137.278 23.5713 136.911 23.7236C136.544 23.8758 136.21 24.0989 135.929 24.3802C135.647 24.6615 135.424 24.9954 135.272 25.3629C135.12 25.7304 135.042 26.1243 135.042 26.522V53.522C135.042 63.092 128.469 70.405 120.002 70.405H119.071C110.602 70.405 104.031 63.092 104.031 53.522V26.522C104.031 25.7186 103.712 24.9482 103.144 24.3802C102.576 23.8121 101.805 23.493 101.002 23.493H91.402C90.5987 23.493 89.8283 23.8121 89.2602 24.3802C88.6922 24.9482 88.373 25.7186 88.373 26.522V53.522C88.373 74.565 102.116 85.122 119.073 85.122H120.004Z" fill="white"/>
        <path d="M217.307 27.587L196.851 81.776C196.634 82.3517 196.246 82.8476 195.74 83.1975C195.234 83.5475 194.633 83.735 194.018 83.735H179.806C179.19 83.7352 178.59 83.5478 178.083 83.1978C177.577 82.8478 177.189 82.3519 176.972 81.776L156.514 27.587C156.34 27.1286 156.281 26.6349 156.34 26.1484C156.4 25.6618 156.576 25.1969 156.855 24.7937C157.133 24.3904 157.506 24.0608 157.94 23.8332C158.374 23.6056 158.857 23.4868 159.347 23.487H169.606C170.221 23.4868 170.822 23.6742 171.329 24.0242C171.835 24.3742 172.223 24.8701 172.44 25.446L185.495 60.027C185.604 60.3148 185.798 60.5625 186.051 60.7374C186.304 60.9123 186.604 61.006 186.912 61.006C187.22 61.006 187.52 60.9123 187.773 60.7374C188.026 60.5625 188.22 60.3148 188.329 60.027L201.384 25.448C201.602 24.8723 201.989 24.3765 202.495 24.0265C203.002 23.6766 203.603 23.4891 204.218 23.489H214.473C214.963 23.4887 215.446 23.6074 215.88 23.8349C216.315 24.0624 216.687 24.392 216.966 24.7953C217.245 25.1985 217.421 25.6635 217.481 26.1501C217.54 26.6367 217.481 27.1305 217.307 27.589" fill="white"/>
        <path d="M31.7 69.492H31.622C27.4083 69.4587 23.3784 67.7614 20.4106 64.77C17.4427 61.7785 15.7774 57.7354 15.7774 53.5215C15.7774 49.3076 17.4427 45.2645 20.4106 42.2731C23.3784 39.2817 27.4083 37.5844 31.622 37.551H31.7C38.117 37.551 42.04 39.896 44.887 43.04C45.3781 43.5727 46.0449 43.9105 46.7649 43.9913C47.485 44.0721 48.21 43.8906 48.807 43.48L57.219 37.754C57.5614 37.5225 57.8528 37.2233 58.0751 36.8749C58.2974 36.5264 58.4459 36.1361 58.5115 35.728C58.5771 35.3199 58.5584 34.9027 58.4564 34.5022C58.3545 34.1016 58.1716 33.7262 57.919 33.399C52.225 26.099 43.63 20.49 27.763 22.225C12.659 23.875 0 36.056 0 53.521C0 70.986 12.659 83.167 27.762 84.821C43.629 86.552 52.224 80.945 57.918 73.645C58.1706 73.3179 58.3535 72.9425 58.4554 72.5419C58.5573 72.1413 58.5761 71.7241 58.5105 71.316C58.4449 70.9079 58.2964 70.5176 58.0741 70.1692C57.8518 69.8207 57.5604 69.5215 57.218 69.29L48.806 63.564C48.209 63.1534 47.484 62.9719 46.7639 63.0527C46.0439 63.1335 45.3771 63.4713 44.886 64.004C42.043 67.145 38.121 69.492 31.7 69.492Z" fill="white"/>
        <path d="M236.048 83.735H226.448C226.05 83.7351 225.656 83.6569 225.289 83.5047C224.921 83.3525 224.587 83.1294 224.306 82.8481C224.025 82.5668 223.801 82.2328 223.649 81.8653C223.497 81.4977 223.419 81.1038 223.419 80.706V26.517C223.419 26.1192 223.497 25.7252 223.649 25.3577C223.801 24.9901 224.025 24.6562 224.306 24.3749C224.587 24.0936 224.921 23.8705 225.289 23.7183C225.656 23.5661 226.05 23.4878 226.448 23.488H236.048C236.446 23.488 236.84 23.5663 237.207 23.7186C237.574 23.8708 237.908 24.0939 238.189 24.3752C238.471 24.6565 238.694 24.9904 238.846 25.3579C238.998 25.7254 239.076 26.1192 239.076 26.517V80.707C239.076 81.1047 238.998 81.4986 238.846 81.8661C238.694 82.2335 238.471 82.5675 238.189 82.8487C237.908 83.13 237.574 83.3532 237.207 83.5054C236.84 83.6576 236.446 83.735 236.048 83.735Z" fill="white"/>
        <path d="M239.077 7.829C239.077 9.37767 238.618 10.8916 237.758 12.1794C236.898 13.4672 235.675 14.4709 234.244 15.0637C232.813 15.6565 231.239 15.8117 229.72 15.5097C228.201 15.2077 226.806 14.462 225.711 13.367C224.616 12.272 223.87 10.8768 223.568 9.35793C223.265 7.83903 223.42 6.26462 224.013 4.83382C224.606 3.40302 225.609 2.18008 226.897 1.31966C228.184 0.459247 229.698 1.26301e-08 231.247 0C233.323 0 235.315 0.824839 236.783 2.29306C238.251 3.76128 239.076 5.75262 239.076 7.829" fill="white"/>
        </g>
        </svg>
        
      </div>
    </div>
  </v-overlay>
</template>

<script>
import { mapState } from "vuex";
import { track } from "@/services/track-custom";
export default {
  name: "LoaderSplash",
  data: () => ({
      createdDatetime: new Date()
    }
  ),
  computed: {
    ...mapState('customer', ["instance"])
  },
  created() {
    this.createdDatetime = new Date();
  },
  destroyed(){
    const destroyedDatetime = new Date();
    const diff = destroyedDatetime - this.createdDatetime; 
    track.trackEventCluvi({front_time_step: diff}, "TrackingSplash");
  }
};
</script>

<style lang="scss">
.overlay-bck.loaderSplash{
  z-index: 999999999!important;
}
  .wrap-load{
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }
  .loader, .loader:before, .loader:after {
  border-radius: 50%;
  width: 1.1em;
  height: 1.1em;
  animation-fill-mode: both;
  animation: bblFadInOut 1.8s infinite ease-in-out;
}
.loader {
  color: #FFF;
  font-size: 5px;
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
  animation-delay: -0.16s;
  display: block;
  margin: 4px -15px 0 15px;
}
.loader:before,
.loader:after {
  content: '';
  position: absolute;
  top: 0;
}
.loader:before {
  left: -2.1em;
  animation-delay: -0.32s;
}
.loader:after {
  left: 2.1em;
}

@keyframes bblFadInOut {
  0%, 80%, 100% { box-shadow: 0 2.5em 0 -1.3em }
  40% { box-shadow: 0 2.5em 0 0 }
}
.wrap-powered{
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  span{
    font-size: 10px;
  }
  svg{
    width: 50px;
    height: auto;
    margin: 7px 0 0 0;
  }
}
    
</style>

